<template>
	<div class="tw-flex tw-flex-col tw--mx-10">
		<div class="tw-w-full tw-pb-6">
			<v-btn color="primary btn-action" @click="goTo('messaging-templates')">
				<img
					:src="`${$imageUrl}/btn-right-arrow.webp`"
					alt="Atrás"
					class="mr-4"
				/>
				Atrás
			</v-btn>
		</div>
		<p-card class="tw-w-full tw-flex tw-p-none">
			<div class="sideBar tw-w-1/5">
				<div class="contentButtons tw-flex tw-gap-y-2"
					v-for="(entity, index) in entities" :key="index">
					<button
						class="list-button"
						@mouseover="selectedEntity(entity, index)"
						ref="button">
						{{ entity.alias }}
					</button>
					<p-card
						v-if="isSubMenuOpen(index) && entity.details.length > 0"
						class="tw-w-72 tw-p-none submenu-list"
						:style="{ top: submenuPosition.top }"
						@mouseleave="hideMouse()">
						<div
							v-for="(detail, indexD) in entity.details"
							:key="indexD"
							>
							<button
								class="list-button"
								@click="selectedDetail(detail)">
								{{ detail.alias }}
							</button>
						</div>
					</p-card>
				</div>
			</div>
			<div class="mainContent tw-p-none tw-m-none tw-w-4/5">
				<div class="tw-p-6 ">
					<label :style="`color:${$appColors.info}; width: 100%;`">Nombre del Template:
						<v-text-field
							solo
							label="Nombre del Template"
							hide-details
							class="input-text"
							v-model="templateName"
						></v-text-field>
					</label>
					<textarea
						class="custom-messaging-input"
						rows="20"
						id="textArea"
						v-model="templateFormat"
						placeholder="Plantillas Personalizada"
					/>
				</div>
				<p-horizontal-divider mx="0" my="0"/>
				<div class="tw-flex tw-justify-center tw-gap-3 tw-p-3">
					<p-button
						type="black"
						@click="goTo('messaging-templates')">Regresar</p-button>
					<p-button
						type="primary"
						:disabled="!validated"
						@click="saveTemplate">{{ nameButton }}</p-button>
				</div>
			</div>
		</p-card>
	</div>
</template>

<script>
	import PCard from '@/modules/shared/components/ui/Card/p-card';
	import PButton from '@/modules/shared/components/ui/p-button';
	import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';

	export default {
		name: 'new-messaging-template',
		data() {
			return {
				drawer: true,
				entities: [],
				selectEntity: {},
				selectDetail: {},
				templateFormat: '',
				templateName: '',
				validated: false,
				activeSubMenuIndex: null,
				submenuPosition: { top: 0, left: 0 },
				isEdit: false,
				dataTemplate: {},
			};
		},
		created() {
			this.loadData();
			if (Object.keys(this.$route.params).length > 0) {
				this.dataTemplate = this.$route.params;
				this.templateFormat = this.dataTemplate.messageFormat;
				this.templateName = this.dataTemplate.name;
				this.isEdit = true;
			}
		},
		components: { PCard, PButton, PHorizontalDivider },
		methods: {
			async loadData() {
				try {
					const { data: response } = await this.$httpPraktiko.get('entities');
					this.entities = response;
				} catch (error) {
					this.showGenericError();
				}
			},
			selectedEntity(entity, index) {
				this.selectEntity = entity;
				this.activeSubMenuIndex = index;
				const buttonRect = this.$refs.button[index].getBoundingClientRect();
				this.submenuPosition = {
					top: buttonRect.top + buttonRect.height,
					// left: buttonRect.left + buttonRect.width,
				};
			},
			hideMouse() {
				this.activeSubMenuIndex = null;
			},
			selectedDetail(detail) {
				this.selectDetail = detail;
				const textArea = document.getElementById('textArea');
				const position = textArea.selectionStart;
				const textBefore = textArea.value.substring(0, position);
				const textAfter = textArea.value.substring(position);
				this.templateFormat = '';
				this.templateFormat += `${textBefore}{{ ${this.selectEntity.name}.${this.selectDetail.nameField} }}${textAfter}`;
				this.activeSubMenuIndex = null;
			},
			isSubMenuOpen(index) {
				return this.activeSubMenuIndex === index;
			},
			async saveTemplate() {
				const url = this.isEdit ? `template-formats/${this.dataTemplate.id}` : 'template-formats';
				const method = this.isEdit ? 'patch' : 'post';
				const message = this.isEdit ? 'Actualizado' : 'Creado';
				const body = {
					code: this.templateName.trim().toLowerCase(),
					name: this.templateName,
					messageFormat: this.templateFormat,
				};
				if (this.isEdit) {
					delete body.code;
				}
				try {
					await this.$httpPraktiko[method](url, body);
					this.showNotification(`Plantilla ${message} exitosamente`);
					this.isEdit = false;
					this.goTo('messaging-templates');
				} catch (error) {
					this.showGenericError();
				}
			},
		},
		computed: {
			nameButton() {
				return this.isEdit ? 'Actualizar' : 'Crear';
			},
		},
		watch: {
			templateFormat: {
				handler(newVal) {
					this.validated = newVal.trim().length > 0;
				},
			},
			templateName: {
				handler(newVal) {
					this.validated = newVal.trim().length > 0;
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
.sideBar {
	height: 100%;
	border-right: 1px solid #e9e9e9;
	border-top-left-radius: 9px;
	border-bottom-left-radius: 9px;
	// padding: 20px 0;
}
.contentButtons {
	position: relative;

	.list-button {
		width: 100%;
		padding: 13px;
		border-bottom: 1px solid color(border-gray);
		font-family: font(bold);
		font-size: size(large);
	}
	.list-button:hover {
		background-color: color(green-dark);
		border-radius: 9px;
		color: color(white);
	}
	.submenu-list {
		position: absolute;
		left: 280px;
		z-index: 4;
	}
}
.mainContent {
	padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/messaging-templates/new-messaging-templates.vue